module.exports = __webpack_public_path__ + "img/facebook-icon.a79ddff7.svg";